"use client";
import React from "react";
import { AboutSection } from "./aboutSection";
import { AboutPageSkeleton } from "@/components/loadingSkeleton/loadingSkeleton";
import { ClientWrapperProps } from "@/dto/clientWrapper";

export function AboutPageClientWrapper({
  merchantMeta,
  merchant,
}: Readonly<ClientWrapperProps>) {
  if (!merchantMeta) {
    return <AboutPageSkeleton />;
  }
  return (
    <AboutSection
      aboutUsImageUrl={merchantMeta.aboutUsGcs}
      aboutUsHeader={merchantMeta.aboutUsTitle}
      aboutUsText={merchantMeta.aboutUsText}
      merchantName={merchant.name}
    />
  );
}
